import React, { Component } from 'react';
import {Doughnut} from "react-chartjs-2";
import AnalyticsDoughnutUtils, {AnalyticsDoughnutPalette} from "./AnalyticsDoughnutUtils";

interface MultiDoughnutProps {
    title: string;
    data: {value: number,label: string,colour: AnalyticsDoughnutPalette}[];
}

interface MultiDoughnutState {
}

export default class MultiDoughnut extends Component<MultiDoughnutProps, MultiDoughnutState> {
    static displayName = MultiDoughnut.name;


    constructor(props: MultiDoughnutProps) {
        super(props);

        this.state = {
        };
    }

    componentDidMount(): void {
    }

    componentDidUpdate(prevProps: Readonly<MultiDoughnutProps>, prevState: Readonly<MultiDoughnutState>, snapshot?: any): void {
    }
    
    render(): JSX.Element {

        const chartOptions = AnalyticsDoughnutUtils.chartOptions(this.props.title);

        const MultiDoughnutChartData = {
            labels: this.props.data.map(d => d.label),
            datasets: [{
                data: this.props.data.map(d => d.value),
                backgroundColor: this.props.data.map(d => d.colour)
            }]
        };

        return (
            <div className="doughnut-holder doughnut-holder--medium doughnut-holder--centered">
                <Doughnut data={MultiDoughnutChartData} options={chartOptions} height={2} width={4}/>
            </div>
        );
    }
}